<template>
    <div>


        <div class="sidebar-container">
            <div class="sidemenu-container navbar-collapse collapse fixed-menu">
                <div id="remove-scroll" class="left-sidemenu"  >

                    <!-- SUPERCOACH -->
                    <ul class="sidemenu  page-header-fixed slimscroll-style" v-if="CHECK_TYPE(100)"
                        data-keep-expanded="false"
                        data-auto-scroll="true" data-slide-speed="0" style="padding-top: 40px">
                        <li class="sidebar-toggler-wrapper hide">
                            <div class="sidebar-toggler">
                                <span></span>
                            </div>
                        </li>

                        <li class="nav-item start active open"

                        >
                            <a href="/adm/supercoach" class="nav-link nav-toggle">
                                <i class="fas fa-search"></i>
                                &nbsp;&nbsp;<span class="title">Cerca Corsisti</span>
                                <span class="selected"></span>
                            </a>
                        </li>









                    </ul>


                    <!-- COACH -->
                    <ul class="sidemenu  page-header-fixed slimscroll-style" v-if="CHECK_TYPE(98)"
                        data-keep-expanded="false"
                        data-auto-scroll="true" data-slide-speed="0" style="padding-top: 40px">
                        <li class="sidebar-toggler-wrapper hide">
                            <div class="sidebar-toggler">
                                <span></span>
                            </div>
                        </li>

                        <!-- <li class="nav-item start active open"

                        >
                            <a href="/adm/coach" class="nav-link nav-toggle">
                                <i class="fas fa-search"></i>
                                &nbsp;&nbsp;<span class="title">Cerca Corsisti</span>
                                <span class="selected"></span>

                            </a>
                        </li> -->

                        <li class="nav-item start active open"

                        >
                            <a href="/adm/stats" class="nav-link nav-toggle">
                                <i class="fas fa-chart-pie"></i>
                                &nbsp;&nbsp;<span class="title">Stats Generali</span>
                                <span class="selected"></span>

                            </a>
                        </li>

                        <!-- <li class="nav-item start active open"

                        >
                            <a href="/adm/users/sink" class="nav-link nav-toggle">
                                <i class="fas fa-users"></i>
                                &nbsp;&nbsp;<span class="title">Ultime iscrizioni</span>
                                <span class="selected"></span>

                            </a>
                        </li>

                        <li class="nav-item start active open"

                        >
                            <a href="/adm/users/" class="nav-link nav-toggle">
                                <i class="fas fa-users"></i>
                                &nbsp;&nbsp;<span class="title">Utenti</span>
                                <span class="selected"></span>

                            </a>
                        </li> -->

                        <li class="nav-item start active open"

                        >
                            <a href="/adm/email" class="nav-link nav-toggle">
                                <i class="fas fa-envelope"></i>
                                &nbsp;&nbsp;<span class="title">Invio email</span>
                                <span class="selected"></span>

                            </a>
                        </li>


                    </ul>


                    <!-- CLASSIC USER AND TEAM -->
                    <ul class="sidemenu  page-header-fixed slimscroll-style"
                        v-if="CHECK_TYPE(99) === true || CHECK_TYPE(0) === true" data-keep-expanded="true"
                        data-auto-scroll="true" data-slide-speed="200" style="padding-top: 60px">
                        <li class="sidebar-toggler-wrapper hide">
                            <div class="sidebar-toggler">
                                <span></span>
                            </div>
                        </li>




                        <li class="nav-item start active open"
                            v-if="CHECK_ROLE_SIDEBAR(100)"

                        >
                            <router-link :to="{name: 'N_Dashboard'}" class="nav-link nav-toggle">

                                <i class="fas fa-square abtg__icon-menu-dashboard" style="color:#f07623 !important"></i>
                                &nbsp;&nbsp;<span class="title">{{$t('dashboard.sb_mappatura_scan')}}</span>

                            </router-link>

                        </li>



                        <li class="nav-item start active open"
                            v-if="CHECK_ROLE_SIDEBAR(100)"

                        >
<!--                            <router-link :to="{name: 'N_Mapping'}" class="nav-link nav-toggle">-->

                          <a href="/mapping" class="nav-link nav-toggle">
                                <i class="fas fa-square abtg__icon-menu-dashboard" style="color:#f07623 !important"></i>
                                &nbsp;&nbsp;<span class="title">{{$t('dashboard.sb_archivio_mappatura')}}</span>
                          </a>
<!--                            </router-link>-->

                        </li>

                        <li class="nav-item start active open"
                            v-if="CHECK_ROLE_SIDEBAR(100)"

                        >
                            <router-link :to="{name: 'N_StarredMapping'}" class="nav-link nav-toggle">

                                <i class="fas fa-star abtg__icon-menu-dashboard" style="color:#f07623 !important"></i>
                                &nbsp;&nbsp;<span class="title">{{$t('dashboard.sb_mie_operazioni')}}</span>
                                <hr class="abtg__hr-menu">
                            </router-link>

                        </li>



                      <li class="nav-item start active open"
                          v-if="CHECK_ROLE_SIDEBAR(100)"

                      >
                        <!--                            <router-link :to="{name: 'N_Mapping'}" class="nav-link nav-toggle">-->

                        <a href="/services/wallet" class="nav-link nav-toggle">

                          <i class="fas fa-square abtg__icon-menu-dashboard" style="color:forestgreen !important"></i>
                          &nbsp;&nbsp;<span class="title">Wallet</span>


                        </a>


                      </li>


                      <li class="nav-item start active open"
                          v-if="CHECK_ROLE_SIDEBAR(100)"

                      >
                        <!--                            <router-link :to="{name: 'N_Mapping'}" class="nav-link nav-toggle">-->

                        <a href="/services/info_compravendita" class="nav-link nav-toggle">

                          <i class="fas fa-square abtg__icon-menu-dashboard" style="color:#f07623 !important"></i>
                          &nbsp;&nbsp;<span class="title">Atti Vendita</span>

                        </a>

                      </li>

                      <li class="nav-item start active open"
                          v-if="CHECK_ROLE_SIDEBAR(100)"

                      >
                        <!--                            <router-link :to="{name: 'N_Mapping'}" class="nav-link nav-toggle">-->

                        <a href="/services/info_catasto" class="nav-link nav-toggle">

                          <i class="fas fa-square abtg__icon-menu-dashboard" style="color:#f07623 !important"></i>
                          &nbsp;&nbsp;<span class="title">Visura Catastale</span>

                        </a>

                      </li>

                      <li class="nav-item start active open"
                          v-if="CHECK_ROLE_SIDEBAR(100)"

                      >
                        <!--                            <router-link :to="{name: 'N_Mapping'}" class="nav-link nav-toggle">-->

                        <a href="/services/info_idealista" class="nav-link nav-toggle">

                          <i class="fas fa-square abtg__icon-menu-dashboard" style="color:#f07623 !important"></i>
                          &nbsp;&nbsp;<span class="title">Idealista</span>

                        </a>
                        <hr class="abtg__hr-menu">
                      </li>



                        <li class="nav-item start active open"
                            v-if="CHECK_ROLE_SIDEBAR(100) === false"
                        >
                            <a href="#" class="nav-link nav-toggle">
                                <i class="fas fa-circle abtg__icon-menu-dashboard" style="color:#909090 !important"></i>
                                &nbsp;&nbsp;<span class="title" style="color:#909090">{{$t('dashboard.sb_mappatura_scan')}}</span>
                                <hr class="abtg__hr-menu">
                            </a>

                        </li>


                        <li class="nav-item start active open"
                            v-if="CHECK_ROLE_SIDEBAR(200) && !CHECK_LANGUAGE('es')" >

                            <router-link :to="{name: 'N_AuctionMap'}" class="nav-link nav-toggle">

                                <i class="fas fa-square abtg__icon-menu-dashboard" style="color:grey !important"></i>
                                &nbsp;&nbsp;<span class="title">Aste  </span>
                            </router-link>

                        </li>
                        <li class="nav-item start active open"  v-if="!CHECK_LANGUAGE('es')" >
                            <router-link :to="{name: 'N_Auction'}" class="nav-link nav-toggle">
                                <i class="fas fa-square abtg__icon-menu-dashboard" style="color:grey !important"></i>
                                &nbsp;&nbsp;<span class="title">Archivio Aste</span>

                            </router-link>

                        </li>
                        <li class="nav-item start active open" v-if="!CHECK_LANGUAGE('es')">
                            <router-link :to="{name: 'N_StarredAuction'}" class="nav-link nav-toggle">

                                <i class="fas fa-circle abtg__icon-menu-dashboard" style="color:green !important"></i>
                                &nbsp;&nbsp;<span class="title">Le Mie Operazioni</span>
                                <hr class="abtg__hr-menu">
                            </router-link>

                        </li>



                        <li class="nav-item start active open"

                        >
                            <router-link :to="{name: 'N_Team'}" class="nav-link nav-toggle">
                                <i class="fas fa-square" style="color:#2383cd !important"></i>
                                &nbsp;&nbsp;<span class="title">{{$t('dashboard.sb_mio_team')}}</span>

                            </router-link>

                            <router-link :to="{name: 'N_Task'}" class="nav-link nav-toggle">
                                <i class="fas fa-square" style="color:#2383cd !important"></i>
                                &nbsp;&nbsp;<span class="title">{{$t('dashboard.sb_mio_task')}}</span>
                                <hr class="abtg__hr-menu">
                            </router-link>
                        </li>
                        <li class="nav-item start active"
                        >
                            <router-link :to="{name: 'N_Tutorial'}" class="nav-link nav-toggle">
                                <i class="fas fa-square" style="color: #cb1b1e !important"></i>
                                &nbsp;&nbsp;<span class="title">Video Tutorial

                             </span>

                            </router-link>
                        </li>

                        <li class="nav-item start active"
                            v-if="!CHECK_LANGUAGE('es')"
                             >
                            <router-link :to="{name: 'N_News'}" class="nav-link nav-toggle">
                                <i class="fas fa-square" style="color: #cb1b1e !important"></i>
                                &nbsp;&nbsp;<span class="title">ABTG News</span>
                                <span class="selected"></span>
                            </router-link>
                        </li>

                        <li class="nav-item start active open"
                            v-if="!CHECK_LANGUAGE('es')">
                            <router-link :to="{name: 'N_Pills'}" class="nav-link nav-toggle">
                                <i class="fas fa-square" style="color: #cb1b1e !important"></i>
                                &nbsp;&nbsp;<span class="title">{{$t('dashboard.sb_pillole_immobiliari')}}</span>
                                <span class="selected"></span>
                                <hr class="abtg__hr-menu">
                            </router-link>
                        </li>


                        <li class="nav-item start active open">
                            <router-link :to="{name: 'N_Purpose'}" class="nav-link nav-toggle">
                                <i class="fas fa-square" style="color: #6d2db5 !important"></i>
                                &nbsp;&nbsp;<span class="title "><strong>{{$t('dashboard.sb_proponi_idea')}}</strong></span>
                                <span class="selected"></span>
                            </router-link>
                        </li>

                        <li class="nav-item start active open"
                        >
                            <router-link :to="{name: 'N_Version'}" class="nav-link nav-toggle">
                                <i class="fas fa-square" style="color: #6d2db5 !important"></i>
                                &nbsp;&nbsp;<span class="title ">{{$t('dashboard.sb_novita')}}</span>
                                <span class="selected"></span>
                                <hr class="abtg__hr-menu">
                            </router-link>
                        </li>

                        <li class="nav-item start active open"
                        >
                            <router-link :to="{name: 'N_Trash'}" class="nav-link nav-toggle">
                                <i class="fas fa-square" style="color: #23277c !important"></i>
                                &nbsp;&nbsp;<span class="title ">{{$t('dashboard.sb_trash')}}</span>

                            </router-link>
                        </li>

                    </ul>


                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import {mixin} from '@/helpers/helper'
    import {roles} from '@/helpers/roles';
    export default {
        mixins: [mixin, roles],
        components: {},
        data: function () {
            return {

                showIfDashboard: false,
            }
        },

        computed: {

        },
        created() {

        },
        methods: {
        }
    }
</script>

